/** @jsx $jsx */
import { $jsx } from 'framework7';
import Masonry from 'masonry-layout';
import Isotope from 'isotope-layout';
import imagesloaded from 'imagesloaded';
import classie from 'classie';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $f7router = _ref.$f7router,
      $update = _ref.$update,
      $on = _ref.$on,
      $onBeforeMount = _ref.$onBeforeMount,
      $onMounted = _ref.$onMounted,
      $onBeforeUpdate = _ref.$onBeforeUpdate,
      $onUpdated = _ref.$onUpdated,
      $onBeforeUnmount = _ref.$onBeforeUnmount,
      $onUnmounted = _ref.$onUnmounted,
      $store = _ref.$store;
  var bg = $store.getters.bg.value;
  $on('pageInit', function (e, page) {
    console.log('pageInit', page);
    var elem = document.querySelector('.grid');
    var iso = new Isotope(elem, {
      itemSelector: '.grid-item',
      //layoutMode: 'fitRows',
      masonry: {
        columnWidth: 250,
        isFitWidth: true,
        gutter: 5
      }
    });
    $f7.lazy.create('.grid');
    document.querySelector('.grid').style.visibility = "visible";
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page page-current-items" data-name="home">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md color-white">Regresar</span>
          </a>
        </div>
        <div class="title color-white">Regresar al inicio...</div>
      </div>
    </div>

    <!-- Scrollable page content-->
    <div class="page-content">

      <div class="block"></div>

      <div class="block fade-in">

        <div class="grid fade-in">
          <div class="grid-item">
            <div data-background="/static/slides/24.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/21.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/22.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/23.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/1.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/2.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/3.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/4.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/5.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/6.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/7.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/8.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>
          <div class="grid-item">
            <div data-background="/static/slides/9.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>          
          <div class="grid-item">
            <div data-background="/static/slides/10.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>    
          <div class="grid-item">
            <div data-background="/static/slides/11.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>            
          <div class="grid-item">
            <div data-background="/static/slides/12.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>            
          <div class="grid-item">
            <div data-background="/static/slides/13.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>            
          <div class="grid-item">
            <div data-background="/static/slides/14.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div> 
          <div class="grid-item">
            <div data-background="/static/slides/15.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>            
          <div class="grid-item">
            <div data-background="/static/slides/16.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div> 
          <div class="grid-item">
            <div data-background="/static/slides/17.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>            
          <div class="grid-item">
            <div data-background="/static/slides/18.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div> 
          <div class="grid-item">
            <div data-background="/static/slides/19.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div>            
          <div class="grid-item">
            <div data-background="/static/slides/20.jpeg?nocache=" class="lazy lazy-fade-in"></div>
          </div> 
      </div>

    </div>

    

    </div>
  </div>
`
    }
    ;
}

framework7Component.id = 'd3f42989d5';
export default framework7Component;